/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExpenseType
 */
export interface ExpenseType {
    /**
     * 
     * @type {string}
     * @memberof ExpenseType
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof ExpenseType
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ExpenseType
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof ExpenseType
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ExpenseType
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof ExpenseType
     */
    color?: string;
}

/**
 * Check if a given object implements the ExpenseType interface.
 */
export function instanceOfExpenseType(value: object): value is ExpenseType {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ExpenseTypeFromJSON(json: any): ExpenseType {
    return ExpenseTypeFromJSONTyped(json, false);
}

export function ExpenseTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpenseType {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'name': json['name'],
        'icon': json['icon'] == null ? undefined : json['icon'],
        'color': json['color'] == null ? undefined : json['color'],
    };
}

export function ExpenseTypeToJSON(json: any): ExpenseType {
    return ExpenseTypeToJSONTyped(json, false);
}

export function ExpenseTypeToJSONTyped(value?: ExpenseType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'name': value['name'],
        'icon': value['icon'],
        'color': value['color'],
    };
}

